import { render, staticRenderFns } from "./PriorityBadge.vue?vue&type=template&id=688bfe0c&scoped=true&"
import script from "./PriorityBadge.vue?vue&type=script&setup=true&lang=js&"
export * from "./PriorityBadge.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./PriorityBadge.vue?vue&type=style&index=0&id=688bfe0c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688bfe0c",
  null
  
)

export default component.exports